import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Success = () => {
  const { t: translator } = useTranslation();

  return (
    <div>
      <p style={{ fontSize: 17 }} className="text-dark">
        {translator("Onboarding-SuccessMsg")}{" "}
        <Link to="/">{translator("Onboarding-SuccessMsg-Home")}</Link>.
      </p>
    </div>
  );
};

export default Success;
